import React from 'react'
import { useMediaQuery } from '@paintscout/ui'
import type { MuiTheme as Theme } from '@paintscout/ui'
import BasePage from 'src/components/layouts/BasePage'
import DocumentTitle from 'src/components/common/DocumentTitle'
import { useTrialDashboardPageStyles } from '../shared/useTrialDashboardPageStyles'
import DeactivatedDashboardDesktop from './desktop/DeactivatedDashboardDesktop'
import DeactivatedDashboardMobile from './mobile/DeactivatedDashboardMobile'

/**
 * The block screen a deactivated account sees (ENG-1532).
 *
 * Renders inside the app shell, so the sidenav stays visible and the user can still reach
 * settings to re-subscribe. It blocks the contractor's own workspace only — nothing on the
 * customer view stops, by design: homeowners keep viewing, accepting, chatting and paying.
 */
export default function DeactivatedDashboard() {
  const classes = useTrialDashboardPageStyles()
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'))

  return (
    <BasePage className={classes.basePage} width="xl">
      <DocumentTitle title="Account Deactivated" />
      {isMobile ? <DeactivatedDashboardMobile /> : <DeactivatedDashboardDesktop />}
    </BasePage>
  )
}
